import React, { useRef } from "react";
import text from "../../content/texts.json";

export default function Contact({ idenfier }) {
  const refForm = useRef(null);

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const formData = new FormData(refForm.current);

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="contact section" id="contact">
      <div className="container">
        <div className="section-head">
          <h2 className="text-center">{text.contact.title}</h2>
        </div>
        <form
          name="contact"
          data-netlify="true"
          onSubmit={handleSubmit}
          ref={refForm}
        >
          <div>
            <label>
              {text.contact.name}: <input type="text" name="name" required />
            </label>
          </div>
          <div>
            <label>
              {text.contact.email}: <input type="email" name="email" required />
            </label>
          </div>
          <div>
            <label>
              {text.contact.message}:
              <textarea name="message" required></textarea>
            </label>
          </div>
          <div>
            <button type="submit">{text.contact.send}</button>
          </div>
          <input type="hidden" name="form-name" value="contact" />
          <input type="hidden" name="slug" value={idenfier} />
        </form>
      </div>
    </div>
  );
}
